
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWind4 as ObiWind4Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-4.js';
 
 
 

 
 export const ObiWind4 = createComponent({
   react: React,
   tagName: 'obi-wind-4',
   elementClass: ObiWind4Element,
   events: {
     
   }
  });
 
 